export default "__VITE_ASSET__dhLj0Upy__"